// The legal review (TX-US-0042): Legal's comments, and the conditions an approval carries. Nothing
// in it is required, and Legal's approval waits on nothing in it. The rows are the shared rows'
// (../sheets/rows.js).

import { sheetOf } from '../sheets/rows.js';

export const SECTIONS = [
  {
    title: 'Legal review',
    rows: [
      { name: 'comments', label: 'Comments', kind: 'longtext' },
      { name: 'conditions', label: 'Conditions of approval', kind: 'longtext' },
    ],
  },
];

const sheet = sheetOf(SECTIONS);

export const ROWS = sheet.rows;
export const { rowLabel, draftFrom, bodyFrom, draftErrors } = sheet;

// Nothing is waited on; named for the panel, which asks every sheet.
export const missingLabels = (names = []) => names.map(rowLabel);
